import { useTranslation } from "react-i18next";
import UnAuthenticatedLayout from "@/layouts/UnAuthenticatedLayout";
import {
  AuthCard,
  AuthCardContainer,
  AuthCardHeader,
  AuthCardTitle,
  AuthCardDescription,
  CardContent,
} from "@/components/ui/auth-card";

export default function InactiveView() {
  const { t } = useTranslation("common");

  return (
    <UnAuthenticatedLayout>
      <AuthCard>
        <AuthCardContainer>
          <AuthCardHeader>
            <AuthCardTitle>{t("errors.inactiveTitle")}</AuthCardTitle>
            <AuthCardDescription>{t("errors.inactiveDescription")}</AuthCardDescription>
          </AuthCardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              <a
                href="mailto:info@graftus.ai"
                className="font-medium text-primary hover:underline"
              >
                info@graftus.ai
              </a>
            </p>
          </CardContent>
        </AuthCardContainer>
      </AuthCard>
    </UnAuthenticatedLayout>
  );
}
